import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const Audio = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_audio_lazy" */
    "./audio.js"
  )
);
const AudioRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    Audio,
    {
      key: node.id,
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  );
};
const AudioLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(AudioRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.AUDIO]: AudioLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
